
import '../css/subpage.less'
import React, { useEffect, useState } from 'react';
import { getImageUrl } from '../config';
import { useTranslation } from 'react-i18next';
import { fetchLocalizedJson } from '../api/fetchLocalizedJson';
import { Carousel, Divider, Space } from "antd";
import PageMeta from '../common/PageMeta';
import SkeletonView from '../common/SkeletonView';
import SubpageTitle from '../common/SubpageTitle';
import * as BusinessEntity from '../entities/Business';
import { BUSINESS_PAGE_META } from '../seo/pageMeta';


const Business: React.FC = () => {
    const { i18n } = useTranslation();
    const [items, setEvents] = useState<BusinessEntity.Business[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setLoading(true);
        fetchLocalizedJson<BusinessEntity.Business[]>("business.json")
            .then(data => {
                setEvents(data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setError(error.message);
                setLoading(false);
            });
    }, [i18n.language]);


    if (loading) {
        return <SkeletonView />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }


    return (
        <div className='subpage business'>
            <PageMeta path="/business" {...BUSINESS_PAGE_META} />
            <SubpageTitle titleJa="事業内容" titleEn="Business" />

            <section className="subpage-section" aria-label="事業紹介スライダー">
            <Carousel autoplay arrows >
                {items.map(item => {
                    const dynamicContentStyle = {
                        height: '300px',
                        width: '100vw',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        justifyContent: 'center',
                        padding: "4px",
                        backgroundImage: `url(${getImageUrl(item.coverUrl)})`,

                    };
                    return (item.coverUrl &&
                        < >
                            <Space style={dynamicContentStyle} align="center">
                                <Space direction="vertical" style={{ backgroundColor: "rgba(255, 255, 255, 0.8)", minWidth: "100px", padding: "10px", textAlign: "center", borderRadius: "10px" }}>
                                    <h3>{item.title}</h3>
                                    <p>{item.subTitle}</p>
                                </Space>
                            </Space>
                        </>
                    );
                })}
            </Carousel>
            </section>
            <section className="subpage-section" aria-label="事業内容詳細">
            <Space direction="vertical" style={{ width: '100%' }} align="center" wrap>
                <Space direction="vertical" className='main' wrap>
                    {items.map(item => (
                        <div id={"content" + item.id} >
                            <h2>{item.title} </h2>
                            <Divider />
                            {item.description && <p style={{ color: '#333' }}>{item.description}</p>}
                            {item.contents && item.contents.map(content => (
                                <>
                                    {content.title &&
                                        <h4 style={{ color: '#333' }}>{content.title}</h4>
                                    }

                                    {content.description &&
                                        <p style={{ color: '#333' }}>{content.description}</p>
                                    }
                                    {content.list &&
                                        <ul style={{ color: '#333' }}>
                                            {content.list.map(requirement => (
                                                <li>{requirement}</li>
                                            ))}
                                        </ul>
                                    }
                                </>
                            ))
                            }
                        </div>
                    ))}
                </Space>
            </Space>
            </section>
        </div>
    );
};

export default Business;